import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { createCategory as createCategoryActions } from '../../../redux/actions/categoriesActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';

export default function CategoryCreate({ open, handleClose }) {
  const dispatch: any = useDispatch();
  const [category, setCategory] = React.useState('');
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  const handleCloseAction = () => {
    setCategory('');
    handleClose();
  };

  const onClickSaveEquipmentCategory = async () => {
    const response: any = await dispatch(
      createCategoryActions({ name: category, brand: selectedBrand }),
    );
    if (response?.status === 200) {
      dispatch(snackbarShowMessage('equipment.category.messages.saveSuccess'));
    }
    handleCloseAction();
    setCategory('');
  };

  const onChangeEquipmentCategory = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const capital =
      event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1);
    setCategory(capital);
  };

  const { t } = useTranslation();

  const createCategoryStrings = {
    create_category: t('createCategories.createCategory'),
    edit_category: t('createCategories.editCategory'),
    new_category: t('createCategories.newCategory'),
    category: t('createCategories.category'),
    add_to_catalog: t('createCategories.addToCatalog'),
    activate: t('createCategories.activate'),
    inactivate: t('createCategories.inactivate'),
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseAction}
      aria-labelledby="form-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle id="form-dialog-title">
        {createCategoryStrings.create_category}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          id="name"
          label={createCategoryStrings.new_category}
          variant="outlined"
          autoComplete="off"
          size="small"
          value={category}
          onChange={onChangeEquipmentCategory}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('app.common.cancel')}
        </Button>
        <Button
          onClick={onClickSaveEquipmentCategory}
          fullWidth
          variant="contained"
          color="secondary"
          disabled={category.length === 0}
        >
          {createCategoryStrings.add_to_catalog}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
